<ng-template [sbmodal]="'sbNavigationModal'">
  <sb-navigation-modal [templateId]="'sbNavigationModal'"></sb-navigation-modal>
</ng-template>
<ng-template [sbmodal]="'selectmodal'">
  <sb-select-modal [templateId]="'selectmodal'"></sb-select-modal>
</ng-template>
<ng-template [sbmodal]="'selectdetailsmodal'">
  <sb-select-details-modal [templateId]="'selectdetailsmodal'"></sb-select-details-modal>
</ng-template>
<ng-template [sbmodal]="'alertmodal'">
  <sb-ask-modal [templateId]="'alertmodal'"></sb-ask-modal>
</ng-template>
<ng-template [sbmodal]="'datePickerModal'">
  <sb-date-picker-modal [templateId]="'datePickerModal'"></sb-date-picker-modal>
</ng-template>
<ng-template [sbmodal]="'freetextModal'">
  <sb-freetext-modal [templateId]="'freetextModal'"></sb-freetext-modal>
</ng-template>
<ng-template [sbmodal]="'freetextFilteredModal'">
  <sb-freetext-filtered-modal [templateId]="'freetextFilteredModal'"></sb-freetext-filtered-modal>
</ng-template>
<ng-template [sbmodal]="'multiFreetextFilteredModal'">
  <sb-multi-freetext-filtered-modal [templateId]="'multiFreetextFilteredModal'"></sb-multi-freetext-filtered-modal>
</ng-template>
<ng-template [sbmodal]="'multiSelectModal'">
  <sb-multi-select-modal [templateId]="'multiSelectModal'"></sb-multi-select-modal>
</ng-template>
<ng-template [sbmodal]="'searchSelectModal'">
  <sb-search-select-modal [templateId]="'searchSelectModal'"></sb-search-select-modal>
</ng-template>
<ng-template [sbmodal]="'askmodal'">
  <sb-confirm-modal [templateId]="'askmodal'"></sb-confirm-modal>
</ng-template>
<ng-template [sbmodal]="'errormodal'">
  <sb-error-modal [templateId]="'errormodal'"></sb-error-modal>
</ng-template>
<ng-template [sbmodal]="'uncaughtmodal'">
  <sb-uncaught-modal [templateId]="'uncaughtmodal'"></sb-uncaught-modal>
</ng-template>
<ng-template [sbmodal]="'forbiddenmodal'">
  <sb-forbidden-modal [templateId]="'forbiddenmodal'"></sb-forbidden-modal>
</ng-template>
<ng-template [sbmodal]="'mediumGroupOverrideModal'">
  <sb-medium-group-override-modal [templateId]="'mediumGroupOverrideModal'"></sb-medium-group-override-modal>
</ng-template>
